export enum ZWAVE_STATUS_CODE {
    MODE_UNKNOWN = -1,
    MODE_NORMAL = 0,
    MODE_ADDING = 1,
    MODE_REMOVING = 2,
    MODE_CONTROLLER_SHIFT = 19,
    MODE_LEARN = 20,
    MODE_MAINTENANCE = 21,
    STATUS_IDLE = 0,
    STATUS_ADDING_MODE = 100,
    STATUS_ADDING_NEW_DEVICE = 110,
    STATUS_ADDING_DEVICE_SUCCESS = 120,
    STATUS_ADDING_DEVICE_FAILURE = 130,
    STATUS_REMOVING_MODE = 200,
    STATUS_REMOVING_DEVICE = 210,
    STATUS_REMOVING_DEVICE_SUCCESS = 220,
    STATUS_REMOVING_DEVICE_FAILURE = 230,
    ERROR_CONTROLLER_ADD_MODE_TIMEOUT = -100,
    ERROR_DEVICE_ALREADY_KNOWN = -110,
    ERROR_OCCURRED_DURING_ADD = -120,
    ERROR_UNEXPECTED_WORKFLOW_DURING_ADD = -130,
    CONFIGURATION_ERROR_DURRING_ADD = -140,
    ERROR_CONTROLLER_REMOVE_MODE_TIMEOUT = -200,
    ERROR_UNEXPECTED_WORKFLOW_DURING_REMOVE = -230,
}

export enum ZWAVE_CONSTANTS {
    ZWAVE_ASSOCIATION_GROUP = 1,
    ZWAVE_CONTROLLER_DEVICE_CLASS = "com.prosyst.mbs.services.zwave.deviceclasses.ZWaveNetworkController",
    ZWAVE_DEVICE_CONFIG_DEVICECLASS = "com.prosyst.mbs.services.zwave.deviceclasses.Configuration",
    STATUS_POLLING_INTERVAL_TIME = 2000,
}

export const ADDING_STATUS_STEPS = {
    PREPARE: $localize`Putting the controller into discovery mode`,
    PREPARE_ACTION: $localize`Please wait`,
    PREPARE_RECOVERY: $localize`Please check that the controller is functioning and connected to the internet. Tap retry to try again.`,
    SEARCHING: $localize`Looking for new device`,
    SEARCHING_ACTION: $localize`Put your new device into pairing mode now`,
    SEARCHING_RECOVERY: $localize`Be sure your new device is in an unpaired state and is within range of the controller. If necessary, move your controller closer to the device. If the device is in a paired state, click 'Remove Device' button to remove the device. `,
    PROCESSING: $localize`Processing new device`,
    PROCESSING_ACTION: $localize`Please wait`,
    PROCESSING_RECOVERY: $localize`We were unable to fully process the device. Please remove the device and try again.`,
    COMPLETE: $localize`Added new device`,
    COMPLETE_ACTION: $localize`Please wait while we load the new device info`,
};

export const REMOVING_STATUS_STEPS = {
    PREPARE: $localize`Setting the controller to removing mode`,
    PREPARE_ACTION: $localize`Please wait`,
    PREPARE_RECOVERY: $localize`Please check that the controller is functioning and connected to the internet. Tap retry to try again.`,
    SEARCHING: $localize`Waiting for notification from a device`,
    SEARCHING_ACTION: $localize`Put your device into unpairing mode now`,
    SEARCHING_RECOVERY: $localize`Be sure your device is in a paired state and is within range of the controller. If necessary, move your controller closer to the device.`,
    PROCESSING: $localize`Processing device removal`,
    PROCESSING_ACTION: $localize`Please wait`,
    PROCESSING_RECOVERY: $localize`We were unable to remove the device. Tap retry to try again.`,
    COMPLETE: $localize`The selected device was removed`,
    COMPLETE_WITH_ERROR: $localize`A device was removed, but it was not the selected one`,
};

export enum STATUS_STEP_STATUSES {
    FAIL = -1,
    LOADING = 0,
    PASS = 1,
}

export const STATUS_STEPS = {
    PREPARE: $localize`prepare`,
    SEARCHING: $localize`searching`,
    PROCESSING: $localize`processing`,
    COMPLETE: $localize`complete`,
};

export enum DEVICE_PROP_KEYS {
    NODE_ID = "node_id",
}
